module.exports = __webpack_public_path__ + "static/img/ic_coin.afce269a.png";